require('./widget/accordion-text');
require('./widget/gallery-prodotto');
require('./widget/tab-prodotto');
require('./widget/faq');
require('./widget/select-lingue');
require('./widget/form-elementor');
require('./widget/tab-support');
require('./widget/popup-cart');


// WEBPACK FOOTER //
// ./js/theme.js